import { Box, Grid, TextField, Typography } from "@mui/material";
import {React,useState} from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "../scenarioSetupNewSlice";
import MultipleSelectChipType from "./MultipleSelectChipType";
import { useEffect } from "react";

const percentText = "(%)";
const commonHeight = sizes.h35;
const SW = sizes.w250;

export default function DefaultSafetyMargin() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.scenarioSetupNew);
	const { DSMHigh, DSMMed, DSMLow, DSMOth,SafetyMargin, customerTypes, selectedCustsCGs } = states;

	useEffect(() => {
		const CGExist = selectedCustsCGs.filter(x => x.type ==="CG"|| x.customerGroupID > 0);
		const CGList = {type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup"};
		let SafetyMarginList = [...SafetyMargin];
		if(CGExist.length > 0){
			let idx = SafetyMargin.findIndex(x => x.typeCode === "CustomerGroup");
			if(idx === -1){
				SafetyMarginList.push(CGList);
			}
		}else{
			let idx = SafetyMargin.findIndex(x => x.typeCode === "CustomerGroup");
			if(idx !== -1){
				SafetyMarginList.splice(idx,1);
			}
		}
		dispatch(setState("SafetyMargin",SafetyMarginList));
	},[selectedCustsCGs]);
	//const[safetyMargin, setSafetyMargin] = useState([...SafetyMargin]);
	const handleStateUpdate = (event, stateName) => {
		const value = event.target.value;
		const type = stateName.type;
		const SM = SafetyMargin.map(obj =>obj.type === type ? { ...obj,safetyMargin:value} : obj);
		dispatch(setState("SafetyMargin", SM));
	};

	return (
		<Box
			sx={{
				mt: 2,
				border: 1,
				borderRadius: 1,
				p: 2,
				borderColor: "#c6c6c6",

			}}
		>
			<Grid item sm={12}>
			<Box>
				<Typography sx={{ color: "black.main", fontWeight: "600", fontSize: 14,}}>
					Default Safety Margin{percentText}
				</Typography>
			</Box>
				<Box>
					<MultipleSelectChipType />
				</Box>
			</Grid>
			<Box sx={{ mt: 2 }}>
				<Grid container columnSpacing={1} rowSpacing={2}>
				{SafetyMargin?.map((data, scType) =>{
					return (
					<Grid item sm={6} md={3}>
						<Box>
							<TextField
								type={"number"}
								id="outlined-basic"
								label={data.type}
								variant="outlined"
								size="small"
								value={data.safetyMargin}
								onChange={(event) =>{
									const inputValue = parseFloat(event.target.value);
    								if (isNaN(inputValue) || inputValue >= 0) {
										handleStateUpdate(event, data)
									}
								}}
							/>
						</Box>
					</Grid>
					);
				})}
				</Grid>
			</Box>
		</Box>
	);
}
